export const matchKeys = {
  all: ['match'] as const,
  questions: (species: 'Cat' | 'Dog', locale: 'en' | 'es') =>
    [...matchKeys.all, 'questions', species, locale] as const,
  publicResults: (matchResultsId: string) =>
    [...matchKeys.all, 'public', matchResultsId] as const,
};
